import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { storeToRefs } from 'pinia';
import { useHeaders } from '../../state';
import LoginBox from '../login/LoginBox.vue';
import { useSlideStore } from '../../store';
import { rlog } from '../../utils';


import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
// 登录组件高度

export default {
  __name: 'HeaderBar',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    _useCssVars(_ctx => ({
      "2452c83a": _unref(logoHeight)
    }));
    const logoHeight = computed(() => `${useHeaders.logoHeight}px`);
    const router = useRouter();
    const route = useRoute();
    // 跳转首页
    const goBack = () => {
      rlog([['action', 'AIPPT_web_outlinepage_logo_button_click']], true);
      router.replace({
        path: '/home'
      });
    };
    // 侧边栏隐藏，logo承担了返回首页的功能，此处交互与侧边栏一样，大纲生成中，禁止点击
    const useSlide = useSlideStore();
    const {
      isDisabled
    } = storeToRefs(useSlide);
    const __returned__ = {
      logoHeight,
      router,
      route,
      goBack,
      useSlide,
      isDisabled,
      get storeToRefs() {
        return storeToRefs;
      },
      get useHeaders() {
        return useHeaders;
      },
      LoginBox,
      get useSlideStore() {
        return useSlideStore;
      },
      get rlog() {
        return rlog;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};